import { inject, Injectable } from '@angular/core';
import { AzureLoginResult, loginRedirect } from '@libs/shared/models';
import { map, Observable } from 'rxjs';
import { AzureOAuthWebService } from './azure';
import { OAuthService } from './oauth.service';

@Injectable()
export class OAuthWebService extends OAuthService {
  private readonly azureOAuthWebService: AzureOAuthWebService = inject(AzureOAuthWebService);

  public override login(): Observable<AzureLoginResult | undefined> {
    // we need to throw this here because we redirect to the azure login site.
    // if we do not throw some known error we show an error toast
    return this.azureOAuthWebService.loginUser().pipe(map(() => {
      throw new Error(loginRedirect);
    }));
  }

  public override register(): Observable<AzureLoginResult | undefined> {
    // same as login: the browser is redirected to the azure sign-up page
    return this.azureOAuthWebService.registerUser().pipe(map(() => {
      throw new Error(loginRedirect);
    }));
  }

  public override logout(): Observable<void> {
    return this.azureOAuthWebService.logout();
  }

  public override refreshToken(): Observable<AzureLoginResult | undefined> {
    return this.azureOAuthWebService.refreshToken();
  }
}
